import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('redFlagConfigCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/management/red-flag-config'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.redFlagConfig,
    cacheName: 'redFlagConfig'
  })
);